<div class="bg-light min-vh-100 d-flex flex-row align-items-center">
  <c-container>
    <c-row class="justify-content-center">
      <c-col md="8">
        <c-card-group>
          <c-card class="p-4">
            <c-card-body>
              <form [formGroup]="recuperacion" (ngSubmit)="recuperarContrasena()" *ngIf="!login" autocomplete="off"
                cForm>
                <h1>Recuperar Contraseña</h1>
                <p class="text-medium-emphasis">Reiniciar contraseña</p>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input autoComplete="Correo" formControlName="email" cFormControl placeholder="Correo" type="email" />
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button type="submit" cButton class="px-4" color="primary" [disabled]="!recuperacion.valid">
                      Recuperar Contraseña
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button type="button" cButton class="px-0" color="link" (click)="mostrarLogin()">
                      Ingresar
                    </button>
                  </c-col>
                </c-row>
              </form>
              <form [formGroup]="forma" (ngSubmit)="loguear()" *ngIf="login" autocomplete="off" cForm>
                <h1>Ingresar</h1>
                <p class="text-medium-emphasis">Ingresar al Administrador</p>
                <c-input-group class="mb-3">
                  <span cInputGroupText>
                    <svg cIcon name="cilUser"></svg>
                  </span>
                  <input autoComplete="Correo" formControlName="email" cFormControl placeholder="Correo" type="email" />
                </c-input-group>
                <c-input-group class="mb-4">
                  <span cInputGroupText>
                    <svg cIcon name="cilLockLocked"></svg>
                  </span>
                  <input autoComplete="current-password" formControlName="password" cFormControl placeholder="Password"
                    type="password" />
                </c-input-group>
                <c-row>
                  <c-col xs="6">
                    <button type="submit" cButton class="px-4" color="primary" [disabled]="!forma.valid">
                      Ingresar
                    </button>
                  </c-col>
                  <c-col class="text-right" xs="6">
                    <button type="button" cButton class="px-0" color="link" (click)="mostrarNuevoPass()">
                      Olvidaste la contraseña?
                    </button>
                  </c-col>
                </c-row>
              </form>
            </c-card-body>
          </c-card>
        </c-card-group>
      </c-col>
    </c-row>
  </c-container>
  <!-- Alerts -->
  <lib-toastify-toast-container position="bottom-right"></lib-toastify-toast-container>
</div>